
import analytics from '~/mixins.js/analytics'

export default {
  components: {
    'id-diagram-lazy-usage': () => import('~/components/diagram/lazy/Usage.vue'),
    'id-diagram-lazy-reviews': () => import('~/components/diagram/lazy/Reviews.vue'),
    'id-diagram-lazy-description': () => import('~/components/diagram/lazy/Description.vue'),
  },
  mixins: [analytics],
  props: {
    diagram: {
      type: Object,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
  },
  methods: {
    trackTabChange ($event) {
      const $this = $event.target
      const tabContentId = $this.dataset.content
      const tabElement = document.getElementById(tabContentId)
      if (tabElement) {
        document.querySelector('.nav-tabs .active').classList.remove('active')
        $this.classList.add('active')
        tabElement.dispatchEvent(new Event('click'))
        const tabTitle = $this.textContent
        this.trackEvent('Tab click', tabTitle)
      }
    }
  }
}
